import PropTypes from 'prop-types';

const IllustrationImageShape = PropTypes.shape({
  contentType: PropTypes.string,
  url: PropTypes.string.isRequired,
  details: PropTypes.shape({
    height: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
    size: PropTypes.number.isRequired,
  }),
});

export const IllustrationShape = PropTypes.shape({
  images: PropTypes.arrayOf(IllustrationImageShape),
});

export const MileageDeductionShape = PropTypes.shape({
  externalId: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  illustration: IllustrationShape,
});

export const ProfessionShape = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  professionTitle: PropTypes.string.isRequired,
  introDescription: PropTypes.string,
  illustration: IllustrationShape,
  subtitle: PropTypes.string,
  mileageTypeIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  seoSlug: PropTypes.string.isRequired,
});

export const ExpenseShape = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  helpText: PropTypes.string.isRequired,
  illustration: IllustrationShape,
});
